import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, FormControl, InputBase } from '@material-ui/core';

import { CurrencyFormat } from '../formats';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[200],
    borderRadius: 4,
    boxShadow: 'none',
    display: 'inline-flex',
    width: 240,
    padding: 0,
    '&:hover': {
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: theme.palette.grey[500]
    }
  },
  labelWrapper: {
    padding: theme.spacing(3)
  },
  verticalLine: {
    borderRightWidth: 2,
    borderRightStyle: 'solid',
    borderRightColor: theme.palette.grey[200]
  },
  fieldset: {
    width: '100%',
    '& input': {
      textAlign: 'center'
    }
  },
  input: {
    fontWeight: theme.typography.h5.fontWeight,
    fontSize: theme.typography.h5.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
    color: theme.palette.common.black,
    '& input': {
      width: '100%',
      height: 40,
      padding: '15px 24px 17px 24px'
    }
  }
}));

export default function MoneyField(props) {
  const { inputBaseProps } = props;

  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <div className={classes.labelWrapper}><Typography variant='subtitle1' component='span'>£</Typography></div>
      <div className={classes.verticalLine}></div>
      <FormControl className={classes.fieldset} component='fieldset'>
        <InputBase
          {...inputBaseProps}
          className={classes.input}
          inputComponent={CurrencyFormat}
          inputProps={{ pattern: '[0-9]*' }}
        />
      </FormControl>
    </Paper>
  )
}
